// extracted by mini-css-extract-plugin
module.exports = {"auto_list":"auto_list-22aa21qx"};